export const DETALIZATION_PERSONAL_DATA_ACTIONS = {
  // CONTROLS FETCH
  FETCH_PERSONAL_DATA: 'DETALIZATION_PERSONAL_DATA:FETCH_PERSONAL_DATA',
  FETCH_PERSONAL_DATA_ERROR: 'DETALIZATION_PERSONAL_DATA:FETCH_PERSONAL_DATA_ERROR',
  FETCH_PERSONAL_DATA_SUCCESS: 'DETALIZATION_PERSONAL_DATA:FETCH_PERSONAL_DATA_SUCCESS',
  // CONTROLS UPDATE
  UPDATE_PERSONAL_DATA: 'DETALIZATION_PERSONAL_DATA:UPDATE_PERSONAL_DATA',
  UPDATE_PERSONAL_DATA_ERROR: 'DETALIZATION_PERSONAL_DATA:UPDATE_PERSONAL_DATA_ERROR',
  UPDATE_PERSONAL_DATA_SUCCESS: 'DETALIZATION_PERSONAL_DATA:UPDATE_PERSONAL_DATA_SUCCESS',
  SET_UPDATE_PERSONAL_DATA_ERROR: 'DETALIZATION_PERSONAL_DATA:SET_UPDATE_PERSONAL_DATA_ERROR',
  // CONTROLS CONFIRM
  CONFIRM_PERSONAL_DATA: 'DETALIZATION_PERSONAL_DATA:CONFIRM_PERSONAL_DATA',
  CONFIRM_PERSONAL_DATA_ERROR: 'DETALIZATION_PERSONAL_DATA:CONFIRM_PERSONAL_DATA_ERROR',
  CONFIRM_PERSONAL_DATA_SUCCESS: 'DETALIZATION_PERSONAL_DATA:CONFIRM_PERSONAL_DATA_SUCCESS',
  SET_CONFIRM_PERSONAL_DATA_ERROR: 'DETALIZATION_PERSONAL_DATA:SET_CONFIRM_PERSONAL_DATA_ERROR',
  // CONTROLS CONFIRMATION CODE
  SEND_CONFIRMATION_CODE: 'DETALIZATION_PERSONAL_DATA:SEND_CONFIRMATION_CODE',
  SEND_CONFIRMATION_CODE_ERROR: 'DETALIZATION_PERSONAL_DATA:SEND_CONFIRMATION_CODE_ERROR',
  SEND_CONFIRMATION_CODE_SUCCESS: 'DETALIZATION_PERSONAL_DATA:SEND_CONFIRMATION_CODE_SUCCESS',
  // CONFIRM MAIL FETCH
  FETCH_CONFIRM_MAIL: 'DETALIZATION_PERSONAL_DATA:FETCH_CONFIRM_MAIL',
  // SET_CONFIRM_DATA
  SET_INITIAL_STATE: 'DETALIZATION_PERSONAL_DATA:SET_INITIAL_STATE',
  SET_CONFIRM_MAIL: 'DETALIZATION_PERSONAL_DATA:SET_CONFIRM_MAIL',
};
